import { render, staticRenderFns } from "./BoardManagement.vue?vue&type=template&id=4ed58dda&scoped=true"
import script from "./BoardManagement.vue?vue&type=script&lang=js"
export * from "./BoardManagement.vue?vue&type=script&lang=js"
import style0 from "./BoardManagement.vue?vue&type=style&index=0&id=4ed58dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed58dda",
  null
  
)

export default component.exports